import { styled } from "@mui/material";

export const successStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 911,
    height: 301,
    borderRadius: "12px",
    bgcolor: "var(--Card-Background, #FAFAFA)",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
  };
  export const CheckmarkImg = styled("img")(() => ({
    position: "absolute",
    top: 107,
    bottom: 44,
    right: 380,
    left: 381,
    width: "150px",
    height: "150px",
  }));
  export const ErrorDiv = styled("div")(() => ({
    color: "var(--Warning-Red, #E52B24)",
    position: "absolute",
    top: 130,
    bottom: 955,
    right: 120,
    left: 120,
    height: 39,
    width: 975,
    fontFamily: "Calibri",
    fontSize: 22,
    fontWeight: 400,
    textAlign: "center",
    lineHeight: "normal",
    fontStyle: "normal",
  }));